module.exports = __webpack_public_path__ + "static/media/no_data_found.fb98d31a.png";